<script>
  import { onDestroy } from 'svelte';
  import { format } from 'svelte-i18n';
  import { useNavigate } from 'svelte-navigator';
  import { Nav } from '@sveltestrap/sveltestrap';
  import { add, differenceInDays, endOfDay, startOfDay } from 'date-fns';

  import { DateFilter } from '@client/components/filters/date';
  import { SearchFilter } from '@client/components/filters/search';
  import { PageHeader } from '@client/components/page';

  import { Tab } from '@client/pages/bizcards/components';
  import { PushHistoryFilters } from '@client/pages/signatures/pusher/components';

  import { appStore } from '@client/stores/app';
  import { days, loadingHistory, pushHistory } from '@client/stores/bizcard-push-history';

  import { QueryParams } from '@client/utils/query-params';

  import PushHistoryCalendar from './push-history-calendar.svelte';
  import PushHistoryTable from './push-history-table.svelte';

  const navigate = useNavigate();

  let show = false;

  let endDate = endOfDay(new Date());
  let filtered = [];
  let search = QueryParams.get('search');
  let showFilters = true;
  let startDate = startOfDay(add(new Date(), { days: -89 }));
  let view = 'list';

  const onDays = (n) => {
    if (n > $days) {
      days.set(n);
    }
  };

  $: if ($loadingHistory) {
    $appStore.loading = true;
  } else {
    $appStore.loading = false;
  }

  onDestroy(() => {
    $appStore.loading = false;
  });

  $: filtered = search?.length
    ? $pushHistory.filter((row) => {
        const searchValue = search.toLowerCase();

        return [...Object.values(row), ...Object.values(row?.note)].some((field) => {
          if (typeof field === 'string') {
            return field.toLowerCase().includes(searchValue);
          }

          return false;
        });
      })
    : $pushHistory;
</script>

<div class="page">
  <PageHeader
    title={$format('label.HISTORY')}
    paths={[
      [$format('label.BUSINESS_CARDS'), '/bizcards/studio'],
      [$format('label.ASSIGNMENT'), '/bizcards/assignment'],
      [$format('label.HISTORY')]
    ]}
  />

  <div class="page-content">
    <Nav pills class="mb-3">
      <Tab on:click={() => navigate('/bizcards/assignment')}>{$format('label.ASSIGNMENT')}</Tab>
      <Tab on:click={() => navigate('/bizcards/assignment/routing')}>{$format('label.ROUTING')}</Tab>
      <Tab active on:click={() => navigate('/bizcards/assignment/history')}>{$format('label.HISTORY')}</Tab>
    </Nav>
    <PushHistoryFilters bind:view onView={(newView) => (view = newView)} bind:showFilters>
      <span slot="left">
        {#if view === 'list'}
          <SearchFilter bind:search />
        {/if}
      </span>
      {#if view === 'list'}
        <DateFilter
          align="right"
          clearable={false}
          isRange
          isMultipane
          showPresets
          bind:startDate
          bind:endDate
          showPresetsOnly={$appStore.mobile}
          onDateChange={({ startDate }) => {
            onDays(differenceInDays(new Date(), new Date(startDate)) + 1);
          }}
        />
      {/if}
    </PushHistoryFilters>
    <div class="py-3">
      {#if view === 'calendar'}
        <PushHistoryCalendar history={$pushHistory} loading={$loadingHistory} {onDays} />
      {:else}
        <PushHistoryTable {startDate} {endDate} bind:history={filtered} loading={$loadingHistory} bind:showFilters />
      {/if}
    </div>
  </div>
</div>
